import { createRoutine } from 'redux-saga-routines';

export const showSurveyBuilderRoutine = createRoutine('SHOW_SURVEY_BUILDER');
export const hideSurveyBuilderRoutine = createRoutine('HIDE_SURVEY_BUILDER');

export const fetchSurveyRoutine = createRoutine('FETCH_SURVEY');
export const fetchDefaultQuestionsRoutine = createRoutine('FETCH_DEFAULT_QUESTIONS');
export const fetchAttributesRoutine = createRoutine('FETCH_ATTRIBUTES');

export const changeSurveyNameRoutine = createRoutine('CHANGE_SURVEY_NAME');
export const changeSurveyDescriptionRoutine = createRoutine('CHANGE_SURVEY_DESCRIPTION');
export const fetchQuestionsRoutine = createRoutine('FETCH_QUESTIONS');
export const setSelectedQuestionsRoutine = createRoutine('SET_SELECTED_QUESTIONS');

export const createQuestionRoutine = createRoutine('CREATE_QUESTION');
export const updateQuestionRoutine = createRoutine('UPDATE_QUESTION');
export const deleteQuestionRoutine = createRoutine('DELETE_QUESTION');

export const saveSurveyRoutine = createRoutine('SAVE_SURVEY');
export const checkSurveyNameRoutine = createRoutine('CHECK_SURVEY_NAME');
